import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[whitespace]'
})
export class WhitespaceDirective {

  constructor(private elem: ElementRef) {
  }

  @HostListener('keyup')
  onKeyPress() {
    const reg = / +/g;
    const value = this.elem.nativeElement.value;
    if (!value.trim()) {
      this.elem.nativeElement.value = value.trim();
    } else {
      this.elem.nativeElement.value = value.replace(reg, ' ');
    }
  }

}
